<template>
  <!-- 导出弹窗 -->
  <el-dialog
    :title="title"
    :visible="visible"
    width="550px"
    @open="handleOpen"
    @close="handleClose"
  >
    <el-form ref="uploadForm" :model="uploadForm" label-width="90px">
      <!-- 表单占位：使用项目的 element-ui 组件 -->
      <el-form-item label="学校" prop="academyCode">
        <el-select
          clearable
          v-model="schoolValue"
          placeholder="请选择"
          style="width: 85%"
        >
          <el-option
            v-for="item in schoolList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学院专业" prop="major">
        <el-cascader
          v-model="uploadForm.collegeMajor"
          :options="collegeMajorList"
          :props="{
            multiple: true,
            checkStrictly: true,
            expandTrigger: 'hover',
            value: 'id',
            label: 'name',
            children: 'majors'
          }"
          style="width: 85%"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="审核时间" prop="auditDateRange">
        <el-date-picker
          v-model="uploadForm.auditDateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 85%"
        />
      </el-form-item>
      <el-form-item label="认证状态" prop="status">
        <el-select
          v-model="uploadForm.status"
          placeholder="请选择"
          style="width: 85%"
          clearable
        >
          <el-option label="已认证" :value="1" />
          <el-option label="未通过" :value="2" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" style="margin-left: 50px;"
        >取 消</el-button
      >
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  GetAttestationSchoolListApi,
  GetSchoolCollegeMajorApi,
  ExportHistoryAttestationXYApi
} from "@/request/requestApi";

export default {
  // 子组件通过 this.$emit('update:visible', false) 来关闭
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: "认证信息导出" }
  },
  data() {
    return {
      // 表单初始值：打开弹窗时重置为这些初始值
      uploadForm: {
        collegeMajor: [],
        auditDateRange: [],
        status: null
      },
      schoolValue: "",
      schoolList: [], // 学校列表
      collegeMajorList: [] // 学院专业option
    };
  },

  watch: {
    // 监听学校选择变化，获取对应的学院专业
    schoolValue(newVal, oldVal) {
      if (newVal) {
        console.log("学校选择变化:", newVal);
        this.uploadForm.collegeMajor = [];
        this.getCollegeMajor();
      }
    }
  },

  methods: {
    // 打开弹窗：重置表单内容（使用 element-ui 的 resetFields）
    handleOpen() {
      this.$nextTick(() => {
        // 获取学校列表
        this.getSchoolList();

        this.schoolValue = "";
        this.uploadForm = {
          collegeMajor: [],
          auditDateRange: [],
          status: null
        };
      });
    },
    // 关闭弹窗：触发 .sync 的约定事件并向父组件抛出 close 事件
    handleClose() {
      this.$emit("update:visible", false);
    },
    // 点击取消：等价于关闭且抛出 cancel 事件
    handleCancel() {
      this.$emit("update:visible", false);
    },
    // 点击确定：校验通过后抛出 confirm 事件，并自动关闭
    handleConfirm() {
      const params = {
        School: this.schoolValue,
        College: [],
        Major: [],
        DateBegin: "",
        DateEnd: "",
        State: this.uploadForm.status
      };

      if (
        Array.isArray(this.uploadForm.collegeMajor) &&
        this.uploadForm.collegeMajor.length > 0
      ) {
        const collegeSet = new Set();
        const majorSet = new Set();
        const list = this.uploadForm.collegeMajor;

        list.forEach(item => {
          if (!Array.isArray(item)) return;
          const a = item[0];
          const b = item[1];
          // 先处理 Major，再处理 College，防止学院数据被删
          // 处理 Major（第二个元素，存在时才加入）
          if (b && !majorSet.has(b)) {
            collegeSet.delete(a);
            majorSet.add(b);
            params.Major.push(b);
            params.College.splice(params.College.indexOf(a), 1);
          }

          // 处理 College（第一个元素）
          if (a && !collegeSet.has(a)) {
            collegeSet.add(a);
            params.College.push(a);
          }
 
        });
      } else {
        params.College = [];
        params.Major = [];
      }

      // 处理日期范围
      if (
        Array.isArray(this.uploadForm.auditDateRange) &&
        this.uploadForm.auditDateRange.length > 0
      ) {
        params.DateBegin = this.uploadForm.auditDateRange[0];
        params.DateEnd = this.uploadForm.auditDateRange[1];
      } else {
        params.DateBegin = "";
        params.DateEnd = "";
      }

      // 使用 URLSearchParams 构造查询参数，数组用重复键，不带 []
      // 注意：axios 传入 URLSearchParams 作为 params 时，会直接使用其 toString()
      // 这一方式可避免默认的数组 brackets 形式（例如 College[]=a&College[]=b）
      const query = new URLSearchParams();
      // 学校
      if (params.School) query.append("School", params.School);
      // 学院（可能多个）
      if (Array.isArray(params.College)) {
        params.College.forEach(c => {
          if (c) query.append("College", c);
        });
      }
      // 专业（可能多个）
      if (Array.isArray(params.Major)) {
        params.Major.forEach(m => {
          if (m) query.append("Major", m);
        });
      }
      // 日期
      if (params.DateBegin !== undefined && params.DateBegin !== null) {
        query.append("DateBegin", params.DateBegin);
      }
      if (params.DateEnd !== undefined && params.DateEnd !== null) {
        query.append("DateEnd", params.DateEnd);
      }
      // 状态
      if (params.State !== undefined && params.State !== null) {
        query.append("State", params.State);
      }

      ExportHistoryAttestationXYApi(query).then(res => {
        if (res.succeed) {
          this.$message.success("导出成功!");
          this.downloadFile(
            window.api.apiurl + res.data,
            this.extractFileName(res.data)
          );
          // 关闭弹窗（父组件通过 .sync 接收）
          this.$emit("update:visible", false);
        }
      });
    },

    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/User/GetAttestationSchoolList");
      // var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          if (this.$store.state.userinfo.isSuper) {
            this.schoolList = res.data.map(v => ({
              id: v.schoolId,
              name: v.schoolName
            }));
          } else {
            // 仅保留被选中的学校，并映射为组件使用的 id/name 字段
            const list = Array.isArray(res.data)
              ? res.data.filter(v => v && v.isSelected === true)
              : [];
            this.schoolList = list.map(v => ({
              id: v.schoolId,
              name: v.schoolName
            }));
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    // 获取学院专业
    getCollegeMajor() {
      var params = {
        School: this.schoolValue
      };
      GetSchoolCollegeMajorApi(params).then(res => {
        if (res.succeed) {
          this.collegeMajorList = res.data;
        }
      });
    },

    downloadFile(url, name = "认证历史列表导出") {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (this.status === 200) {
          const a = document.createElement("a");
          const urlObj = window.URL || window.webkitURL;
          const blob = new Blob([this.response], {
            type: this.getResponseHeader("Content-Type")
          });
          const url = urlObj.createObjectURL(blob);
          a.href = url;
          a.download = name; // 设置下载的文件名
          a.click();
        }
      };
      xhr.send();
    },

    extractFileName(fileUrl) {
      if (!fileUrl) return "";
      // 从路径中提取文件名部分
      // const pathParts = fileUrl.split('\\');
      // 从路径中提取文件名部分（同时处理反斜杠和正斜杠）
      const pathParts = fileUrl.replace(/\\/g, "/").split("/");
      const fullFileName = pathParts[pathParts.length - 1]; // 获取最后一部分

      // 移除扩展名，只保留文件名部分
      const fileNameWithoutExt = fullFileName.split(".")[0];

      return fileNameWithoutExt;
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/view/authentication/components/exportDialog.vue